import { render, staticRenderFns } from "./CustomizeMetalAK.vue?vue&type=template&id=920ae9f4&scoped=true"
import script from "./CustomizeMetalAK.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAK.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAK.vue?vue&type=style&index=0&id=920ae9f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920ae9f4",
  null
  
)

export default component.exports